<template>
  <full-text-url-provider
    v-slot="{ url }"
    :reference-id="reference.id"
  >
    <pdf-document v-if="url" :src="url" :height="height" />
    <div v-else class="loader d-flex justify-center align-center">
      <v-progress-circular indeterminate color="primary" />
    </div>
  </full-text-url-provider>
</template>

<script>
import PdfDocument from '@/components/Common/PdfDocument';
import FullTextUrlProvider from '@/components/FullTextReviewPage/FullTextUrlProvider';
import { Reference } from '@/models';

export default {
  name: 'FullTextPdfPreview',
  components: { PdfDocument, FullTextUrlProvider },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    height: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  height: 500px;
}
</style>
